import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { loadToken } from '../localStorage';

const PrivateRoute = ({ children, ...rest }) => {
  // const token = useSelector((state) => state.token);
  // const token = JSON.parse(localStorage.getItem('token'));
  const token = loadToken();

  return (
    <Route
      {...rest}
      render={() => {
        return token ? children : <Redirect to='/'></Redirect>;
      }}
    ></Route>
  );
};
export default PrivateRoute;
